import { render } from "./ButtonLarge.vue?vue&type=template&id=39a12820&scoped=true"
import script from "./ButtonLarge.vue?vue&type=script&lang=js"
export * from "./ButtonLarge.vue?vue&type=script&lang=js"

import "./ButtonLarge.vue?vue&type=style&index=0&id=39a12820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a12820"]])

export default __exports__